module.exports = __webpack_public_path__ + "static/media/Playlist-Script.bca3345c.svg";